import React from 'react';
import Tippy from '@tippyjs/react';
import TrendBadge from './TrendBadge';
import { KpiCardSkeleton } from './Skeletons';

function KpiCardGrid({ loading, isMobile, columns, cards, comparisonLabel, variant }) {
  const isCentered = variant === 'centered';
  const gridCols = isMobile ? 'repeat(2, 1fr)' : `repeat(${columns}, 1fr)`;

  if (loading) {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: gridCols, gap: 12, marginBottom: 24 }}>
        {Array.from({ length: columns }, (_, i) => <KpiCardSkeleton key={i} />)}
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: gridCols, gap: 12, marginBottom: 24 }}>
      {cards.map((card, idx) => (
        <div
          key={card.top.label || idx}
          style={{
            background: 'var(--sl-bg-primary, #fff)',
            border: '1px solid var(--sl-border-secondary, #e4e7ec)',
            borderRadius: 8,
            padding: isCentered ? '16px 20px' : '16px 16px 14px',
            textAlign: isCentered ? 'center' : undefined,
          }}
        >
          <div
            className={`d-flex align-items-center ${isCentered ? 'justify-content-center' : 'justify-content-between'}`}
            style={{ gap: 6, marginBottom: isCentered ? 6 : 8 }}
          >
            <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--sl-text-tertiary, #667085)' }}>
              {card.top.href ? (
                <a href={card.top.href} style={{ color: 'inherit', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  {card.top.label}
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
                    <path d="M3 8h10M9 4l4 4-4 4" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              ) : card.top.label}
            </span>
            {card.top.tooltip && (
              <Tippy content={card.top.tooltip} placement="top" arrow={false} theme="reporting">
                <span style={{ cursor: 'help', color: 'var(--sl-text-disabled, #98a2b3)', fontSize: 14, lineHeight: 1 }}>
                  <i className="far fa-info-circle" />
                </span>
              </Tippy>
            )}
          </div>
          <div style={{ fontSize: 26, fontWeight: 700, color: 'var(--sl-text-primary, #101828)', lineHeight: 1.2, marginBottom: isCentered ? 4 : 6 }}>
            {card.top.value}
          </div>
          {isCentered
            ? <div className="d-flex justify-content-center"><TrendBadge current={card.top.current} prior={card.top.prior} delta={card.top.delta} label={comparisonLabel} /></div>
            : <TrendBadge current={card.top.current} prior={card.top.prior} delta={card.top.delta} label={comparisonLabel} />
          }

          {card.bottom && (
            <div style={{ borderTop: '1px solid var(--sl-bg-tertiary, #f2f4f7)', marginTop: isCentered ? 4 : 12, paddingTop: isCentered ? 4 : 12 }}>
              <div
                className={`d-flex align-items-center ${isCentered ? 'justify-content-center' : 'justify-content-between'}`}
                style={{ gap: 6, marginBottom: isCentered ? 4 : 8 }}
              >
                <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--sl-text-tertiary, #667085)' }}>{card.bottom.label}</span>
                {card.bottom.tooltip && (
                  <Tippy content={card.bottom.tooltip} placement="top" arrow={false} theme="reporting">
                    <span style={{ cursor: 'help', color: 'var(--sl-text-disabled, #98a2b3)', fontSize: 14, lineHeight: 1 }}>
                      <i className="far fa-info-circle" />
                    </span>
                  </Tippy>
                )}
              </div>
              <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--sl-text-primary, #101828)', lineHeight: 1.2, marginBottom: isCentered ? 4 : 6 }}>
                {card.bottom.value}
              </div>
              {isCentered
                ? <div className="d-flex justify-content-center"><TrendBadge current={card.bottom.current} prior={card.bottom.prior} delta={card.bottom.delta} label={comparisonLabel} /></div>
                : <TrendBadge current={card.bottom.current} prior={card.bottom.prior} delta={card.bottom.delta} label={comparisonLabel} />
              }
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default KpiCardGrid;
